import { Component, Input } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-message",
	templateUrl: "./message.component.html",
})
export class MessageComponent {
	@Input() imageSrc = null;
	@Input() imageAlt: string = "";
	@Input() userName: string;
	@Input() date: string;
	@Input() message: string;
	protected backendURL = environment.backendURL;
	protected avatarImageUrl;
	constructor() {}

	ngOnInit() {
		if (this.imageSrc != null) {
			this.avatarImageUrl = this.backendURL + this.imageSrc;
		}
	}
}
